import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/business-disciplines/profile/loading';

export const Route = createFileRoute('/_private/settings/business-disciplines/$id')({
  pendingComponent: Loading,
});
